import { Button, Table, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers-pro';
import styled from 'styled-components';

/**
 * Styled version of MUI components - using this instead of the sx prop
 */

export const StyledTableContainer = styled(TableContainer)`
  box-shadow: none;
  border: 1px solid ${(props) => props.theme.colors.greys.light};
  border-radius: 8px;
  margin-bottom: 8px;
`;

export const StyledTable = styled(Table)`
  min-width: 448px;
`;

export const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: ${(props) => props.theme.colors.greys.light};
    }
    &:hover fieldset {
      border-color: ${(props) => props.theme.colors.greys.dark};
    }
    &.mui-focused fieldset {
      border-color: ${(props) => props.theme.colors.greys.darkest};
    }
  }
`;

export const StyledTableHeaderCell = styled(TableCell)`
  font: ${(props) => props.theme.fonts.textBigHeight24};
  color: ${(props) => props.theme.colors.greys.darkest};

  &:not(:last-child) {
    border-right: 1px solid ${(props) => props.theme.colors.greys.light};
  }
`;

export const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: ${(props) => props.theme.colors.greys.lighter};
  }

  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;

export const NameCell = styled(TableCell)`
  padding: 12px 16px;
  min-width: 200px;
`;

export const TimeSlotCell = styled(TableCell)`
  padding: 12px 16px;
  min-width: 200px;

  & .MuiInputBase-input {
    padding: 0 0 0 8px !important;
  }
`;

export const ActionButton = styled(Button)`
  color: ${(props) => props.theme.colors.greys.darkest};
  padding: 12px;
`;

export const StyledTimePicker = styled(TimePicker)`
  ${(props) =>
    props.hasOverlapError &&
    `
    & .MuiOutlinedInput-root {
      & fieldset {
        border-color: ${props.theme.colors.infoRed};
        border-width: 1px;
      }
      &:hover fieldset {
        border-color: ${props.theme.colors.infoRed};
        border-width: 1px;
      }
      &.Mui-focused fieldset {
        border-color: ${props.theme.colors.infoRed};
        border-width: 1px;
      }

      & .MuiInputBase-input {
        color: ${props.theme.colors.infoRed};
      }

      & .MuiInputAdornment-root .MuiIconButton-root {
        color: ${props.theme.colors.infoRed};
      }
    }
  `}
`;

export const actionBarStyle = {
  justifyContent: 'center',
  width: '100%',
  display: 'flex',
  '& .MuiButton-root': {
    flex: 1,
    width: '100%',
  },
};

export const timePickerPopperStyle = {
  '& .MuiPaper-root': {
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
  },
};
